export const initialData = [
  {
    persona: 'Stable Status Quo',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Rustic Landscapes',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Rooted Renters',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Right on Main Street',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Metropolitan Comforts',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Settled Homeowners',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Middle of the Road',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Independent Neighbors',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Small-Town Strivers',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Working-Class Commuters',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'American Mosaic',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Strollers and Starter Homes',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Established Empty-Nesters',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'High Hopes',
    percentage: 100,
    personaCount: 0
  },
  {
    persona: 'Educated Cosmopolitans',
    percentage: 100,
    personaCount: 0
  }
]
